export const ACCOUNT_SETUP_MIN_DATE = new Date(2023, 0, 1); // 1 Jan, 2023
